'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import Input from '../Input/index.js';
import { SalaryLabel, InputSalaryWrapper, InputWrapper, SelectWrapper } from './InputSalary.css.js';
import MultipleRadio from '../MultipleRadio/index.js';
import { getSalaryCurrencies } from './services.js';
import { ELanguage } from '../Utils/constants.js';

var MAX_JOB_SALARY_LENGTH = 12;
var DEFAULT_INPUT_SALARY_OPTIONS = {
    maxLength: MAX_JOB_SALARY_LENGTH,
    label: ''
};
var InputSalary = function (props) {
    var salary = props.salary, currencyId = props.currencyId, _a = props.options, options = _a === void 0 ? DEFAULT_INPUT_SALARY_OPTIONS : _a, _b = props.onChange, onChange = _b === void 0 ? function () { } : _b, msBaseUrl = props.msBaseUrl, _c = props.langCode, langCode = _c === void 0 ? ELanguage : _c, _d = props.isMobile, isMobile = _d === void 0 ? false : _d;
    var _e = useState(false), isFocus = _e[0], setFocus = _e[1];
    var _f = useState([]), currencies = _f[0], setCurrencies = _f[1];
    var handleOnChangeValue = function (value) {
        // check is number
        value = value.replaceAll(',', '');
        var parsedValue = parseInt(value);
        if (value.length <= MAX_JOB_SALARY_LENGTH) {
            onChange && onChange(isNaN(parsedValue) ? 0 : parsedValue, currencyId);
        }
    };
    var handleOnChangeCurrency = function (currencyId) {
        if (salary.toString().length <= MAX_JOB_SALARY_LENGTH) {
            onChange && onChange(salary, currencyId);
        }
    };
    var formatCurrency = function (value) {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0
        });
        return formatter.format(value).replace('$', '');
    };
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var salaryCurrencies, formattedCurrencies;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, getSalaryCurrencies(msBaseUrl)];
                    case 1:
                        salaryCurrencies = _g.sent();
                        if (!((_b = (_a = salaryCurrencies === null || salaryCurrencies === void 0 ? void 0 : salaryCurrencies.data) === null || _a === void 0 ? void 0 : _a.relationships) === null || _b === void 0 ? void 0 : _b.data)) {
                            return [2 /*return*/];
                        }
                        if (((_d = (_c = salaryCurrencies === null || salaryCurrencies === void 0 ? void 0 : salaryCurrencies.data) === null || _c === void 0 ? void 0 : _c.relationships) === null || _d === void 0 ? void 0 : _d.data.length) === 0) {
                            return [2 /*return*/];
                        }
                        formattedCurrencies = (_f = (_e = salaryCurrencies === null || salaryCurrencies === void 0 ? void 0 : salaryCurrencies.data) === null || _e === void 0 ? void 0 : _e.relationships) === null || _f === void 0 ? void 0 : _f.data.map(function (item) { return ({
                            id: item.id,
                            name: langCode === ELanguage.VI ? item.attributes.nameVi : item.attributes.nameEn
                        }); });
                        setCurrencies(formattedCurrencies);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        options.label !== '' ? React__default.createElement(SalaryLabel, { htmlFor: 'jobSalary' }, options.label) : React__default.createElement(React__default.Fragment, null),
        React__default.createElement(InputSalaryWrapper, { isFocus: isFocus },
            React__default.createElement(InputWrapper, null,
                React__default.createElement(Input, { type: 'text', id: 'jobSalary', isRequired: true, onChange: handleOnChangeValue, onFocus: function () { return setFocus(true); }, onBlur: function () { return setFocus(false); }, value: salary > 0 ? formatCurrency(salary !== null && salary !== void 0 ? salary : 0).toString() : '', placeholder: '0', maxLength: options.maxLength })),
            React__default.createElement(SelectWrapper, null,
                React__default.createElement(MultipleRadio, { options: currencies, name: 'select-currency', value: currencyId, onChange: function (_a) {
                        var value = _a.value;
                        return handleOnChangeCurrency(value);
                    }, dropdownStyle: {
                        minWidth: 120
                    }, placement: 'bottom-end', isMobile: isMobile })))));
};

export { InputSalary as default };
//# sourceMappingURL=index.js.map
